<template>
  <div class="page-container">
    <el-row :gutter="18">
      <el-col :span="24">
        <h2 class="mt-0">Dashboard</h2>
      </el-col>
    </el-row>
    <el-row :gutter="18">
      <el-col :sm="24" :md="12" class="mb-3">
        <el-card class="box-card">
          <div slot="header">
            <i class="fa fa-money-bill"></i> Early Bird Program
          </div>
          <p>
            Client wants to apply for the Early Bird Advance on their FIRST visit using paystub(s) and/or W-2(s).
            If approved for the Early Bird Advance the client will receive $50 cash instantly.
          </p>
          <p><el-button type="primary" @click="goToEarlyBirdApplication">Begin or Continue Application</el-button></p>
        </el-card>
      </el-col>
      <el-col :sm="24" :md="12" class="mb-3">
        <el-card class="box-card">
          <div slot="header">
            <i class="fa fa-file-invoice"></i> Docutax
          </div>
          <p>
            Docutax is a secure platform to communicate and share documents with your tax clients. Use Docutax to request
            documents from your clients or review submitted documents.
          </p>
          <p><el-button type="primary" @click="goToDocutax">Docutax</el-button></p>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="18">
      <el-col :sm="12" :md="12" class="mb-3">
        <el-card class="box-card">
          <div slot="header">
            <i class="fa fa-retweet"></i> Log Refer-A-Friend Coupon
          </div>
          <p>New client is filing their tax return and uses a Refer-A-Friend coupon. Log the Refer-A-Friend Coupon for
            referring client to get credit.</p>
          <p><el-button type="primary" @click="logReferralDialogVisible = true">Log Referral</el-button></p>
        </el-card>
      </el-col>
      <el-col :sm="12" :md="12" class="mb-3">
        <el-card class="box-card">
          <div slot="header">
            <i class="fa fa-retweet"></i> Refer-A-Friend Lookup
          </div>
          <p>Referring client inquires about status of new client they referred. Lookup status instantly to answer clients
            question. Payout to clients with valid referrals.</p>
          <p><el-button type="primary" @click="goToRAFPayout">Pay Referral(s)</el-button></p>
        </el-card>
      </el-col>
    </el-row>
    <template v-if="isAdminOrAccountant">
      <el-row :gutter="18">
        <el-col :span="24">
          <h2 class="mt-0">Accountant</h2>
        </el-col>
      </el-row>
      <el-row :gutter="18">
        <el-col :sm="24" :md="6" class="mb-3">
          <el-card class="box-card">
            <div slot="header">
              <i class="fa fa-download"></i> Make Deposit
            </div>
            <p>Submit a deposit to a location.</p>
            <p><el-button type="primary" @click="makeDepositDialogVisible = true">Make Deposit</el-button></p>
          </el-card>
        </el-col>
      </el-row>
      <el-dialog title="Make Deposit" :visible.sync="makeDepositDialogVisible" :close-on-click-modal="false"
        width="350px">
        <make-deposit-dialog @close="makeDepositDialogVisible = false"></make-deposit-dialog>
      </el-dialog>
    </template>
    <el-dialog title="Log Referral" :visible.sync="logReferralDialogVisible" width="50%">
      <log-referral-dialog @close="logReferralDialogVisible = false"></log-referral-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LogReferralDialog from '@/components/dialog-content/LogReferral.vue';
import { DEPARTMENT } from '@/enum/UserDepartments';
import MakeDepositDialog from '@/components/dialog-content/MakeDeposit.vue';


export default {
  data() {
    return {
      signInDialogVisible: false,
      logReferralDialogVisible: false,
      makeDepositDialogVisible: false,
    };
  },
  methods: {
    goToEarlyBirdApplication() {
      this.$router.push('/earlyBirdApplication');
    },
    goToRAFPayout() {
      this.$router.push('/raf/payout');
    },
    goToDocutax() {
      this.$router.push('/docutax/submission');
    },
  },
  computed: {
    ...mapGetters('User', [
      'user',
      'isAdmin',
    ]),
    isAdminOrAccountant() {
      return this.isAdmin || this.user.departmentId === DEPARTMENT.ACCOUNTANT;
    },
  },
  components: {
    LogReferralDialog,
    MakeDepositDialog,
  },
};

</script>

<style lang="scss">
</style>
